import { logger } from "@services/workers/helpers";
import { EmailValidator } from "./validator";

export const emailValidatorNetAPI = async (emailAddress: string) => {
  try {
    const response = await EmailValidator.validateEmail({ emailAddress });
    // EmailValidator.handleResponse(response);
    return response;
  } catch (error) {
    logger.error("EmailValidatorAPI->", "emailValidatorNetAPI", error);
  }
};

declare global {
  interface Window {
    EMAIL: any;
  }
}

window.EMAIL = emailValidatorNetAPI;
